import React from 'react'
import PropTypes from 'prop-types'
import './RadioField.scss'
import RadioButton from '../RadioButton/RadioButton'

const RadioField = ({
  options,
  name,
  handleChange,
  label,
  selectedOption,
  errorMessage,
  isValid,
}) => {
  return (
    <div>
      <label className="Radiofield__label">{label}</label>
      <div
        className="Radiofield"
        onChange={e => handleChange(name, e.target.value)}
      >
        {options.map((option, i) => (
          <RadioButton
            key={i}
            id={`Radiobutton__${name}-${option.value}`}
            name={name}
            checked={selectedOption === option.value}
            label={option.label}
            value={option.value}
          />
        ))}
        {isValid === false && (
          <span className="Textfield__error-message" key="errorMessage">
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  )
}

RadioField.propTypes = {
  options: PropTypes.array,
  selectedOption: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  handleChange: PropTypes.func,
  errorMessage: PropTypes.string,
  isValid: PropTypes.bool,
}
export default RadioField
